import React from 'react';

import { ConversationInfo } from './MessageList.styled';
import { Conversation } from 'screens/Messages/Messages.type';
import { isResolvedConversation } from 'screens/Messages/Messages.utils';

export const ResolvedConversationInfo: React.FC<{
  conversation?: Conversation;
}> = ({ conversation }): JSX.Element | null => {
  if (!conversation) return null;

  const isConversationResolved = isResolvedConversation(conversation?.status);

  if (!isConversationResolved) return null;

  const hasOwner = !!conversation?.assignedToUserName;

  const resolutionMessage = hasOwner
    ? 'A member of the Kindbody team has closed this conversation.'
    : 'This conversation has been automatically closed based on your last message.';

  return (
    <ConversationInfo>
      {resolutionMessage} Please send us a new message if you have another issue or question.
    </ConversationInfo>
  );
};
